import isEmpty from "../lib/isEmpty";

export const postJobValid = (reqBody) => {
  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;

  let errors = {};

  if (isEmpty(reqBody.email)) {
    errors.email = "Email is required";
  } else if (!emailRegex.test(reqBody.email)) {
    errors.email = "Email is invalid";
  }
  if (isEmpty(reqBody.title)) {
    errors.title = "Title is required";
  }
  // if (isEmpty(reqBody.description)) {
  //   errors.description = "Description is required";
  // }
  if (isEmpty(reqBody.userName)) {
    errors.userName = "UserName is required";
  }
  if (isEmpty(reqBody.jobType)) {
    errors.jobType = "JobType is required";
  }
  if (isEmpty(reqBody.experience)) {
    errors.experience = "Experience is required";
  }
  if (isEmpty(reqBody.skills)) {
    errors.skills = "Skills is required";
  }
  if (isEmpty(reqBody.employmentType)) {
    errors.employmentType = "EmploymentType is required";
  }
  if (isEmpty(reqBody.qualification)) {
    errors.qualification = "Qualification is required";
  }
  if (isEmpty(reqBody.gender)) {
    errors.gender = "Gender is required";
  }
  if (isEmpty(reqBody.deadlineDate)) {
    errors.deadlineDate = "DeadlineDate is required";
  }
  if (isEmpty(reqBody.workType)) {
    errors.workType = "WorkType is required";
  }
  if (isEmpty(reqBody.country)) {
    errors.country = "Country is required";
  }
  if (isEmpty(reqBody.state)) {
    errors.state = "State is required";
  }
  if (isEmpty(reqBody.city)) {
    errors.city = "City is required";
  }
  if (isEmpty(reqBody.address)) {
    errors.address = "Address is required";
  }
  if (isEmpty(reqBody.phoneNo)) {
    errors.phoneNo = "Phone Number is required";
  }
  if (isEmpty(reqBody.jobStatus)) {
    errors.jobStatus = "Job Status is required";
  }
  // if (isEmpty(reqBody.salary)) {
  //   errors.salary = "salary is required";
  // }
  // if (isEmpty(reqBody.toSalary)) {
  //   errors.toSalary = "ToSalary is required";
  // }

  if (isEmpty(reqBody.salaryRangeMax)) {
    errors.salaryRangeMax = "Max. salary is required";
  }
  if (isEmpty(reqBody.salaryRangeMin)) {
    errors.salaryRangeMin = "Min. Salary is required";
  }
  if (isEmpty(reqBody.timeline)) {
    errors.timeline = "Timeline is required";
  }

  // if (isEmpty(reqBody.website)) {
  //   errors.website = "Website is required";
  // }
  if (isEmpty(reqBody.noOfOpenings)) {
    errors.noOfOpenings = "openings is required";
  }
  if (isEmpty(reqBody.JobCategory)) {
    errors.JobCategory = "JobCategory is required";
  }
  if (!isEmpty(errors)) {
    return {
      status: false,
      errors,
    };
  }

  return { status: true };
};
